import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FiBell, FiSettings, FiLogOut, FiMenu } from 'react-icons/fi';
import AuthContext from '../../context/AuthContext';

const Header = ({ user }) => {
  const { logout } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  return (
    <header className="bg-white shadow-sm h-16 flex items-center justify-between px-4 md:px-6">
      {/* Mobile menu button */}
      <button 
        className="text-gray-500 hover:text-primary focus:outline-none md:hidden"
        aria-label="Menu"
      >
        <FiMenu size={24} />
      </button>
      
      {/* Empty space for layout balance */}
      <div className="flex-1"></div>
      
      {/* Right side actions */}
      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <button 
          className="text-gray-500 hover:text-primary focus:outline-none relative"
          aria-label="Notifications"
        >
          <FiBell size={20} />
          <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-ui-error"></span>
        </button>
        
        {/* User dropdown */}
        <div className="relative">
          <button 
            className="flex items-center space-x-2 focus:outline-none"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white">
              {user?.name?.charAt(0) || 'U'}
            </div>
            <span className="hidden md:inline-block font-medium text-gray-700">
              {user?.name || 'User'}
            </span>
          </button>
          
          {/* Dropdown menu */}
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
              <div className="px-4 py-2 border-b">
                <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                <p className="text-xs text-gray-500">{user?.email}</p>
              </div>
              
              <Link 
                to="/profile" 
                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
              >
                <FiSettings className="mr-2" />
                Settings
              </Link>
              
              <button 
                onClick={logout}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
              >
                <FiLogOut className="mr-2" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;